
// TODO: could use TypeScript enum
const STATUSES = Object.freeze({
  IDLE: 'idle',
  PENDING: 'pending',
  RESOLVED: 'resolved',
  REJECTED: 'rejected'
});

export default STATUSES;
